import { useSEO } from '../useSEO';

function ProjectsPage() {
  useSEO({
    title: 'Projects | Reset & Run',
    description: 'Explore home organisation and household management projects by Ivy at Reset & Run. Coming soon.',
    path: '/projects',
    robots: 'noindex, nofollow',
  });
  return (
    <main className="subpage">
      <div className="coming-soon">
        <h1>Projects</h1>
        <p>Something exciting is coming soon. Check back shortly to see our work.</p>
      </div>
    </main>
  );
}

export default ProjectsPage;
